import { Link } from "react-router-dom";

export default function CookiePolicyPage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 bg-slate-900">
        <div className="container-custom">
          <h1 className="heading-primary text-white mb-4" data-testid="cookie-title">
            Cookie Policy
          </h1>
          <p className="text-slate-400">Last updated: January 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-testid="cookie-content">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
            <h2 className="heading-tertiary text-slate-900">What Are Cookies</h2>
            <p className="text-slate-600 mb-8">
              Cookies are small text files that are placed on your computer or mobile device when 
              you visit a website. They are widely used to make websites work more efficiently and 
              to provide information to the owners of the site. This Cookie Policy explains how 
              BuyVistas uses cookies and similar technologies.
            </p>

            <h2 className="heading-tertiary text-slate-900">How We Use Cookies</h2>
            <p className="text-slate-600 mb-4">
              BuyVistas uses cookies for the following purposes:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.</li>
              <li><strong>Performance Cookies:</strong> These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.</li>
              <li><strong>Functionality Cookies:</strong> These cookies allow the website to remember choices you make and provide enhanced, more personal features.</li>
              <li><strong>Marketing Cookies:</strong> These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">Types of Cookies We Use</h2>
            
            <h3 className="font-bold text-slate-800 mt-6 mb-2">First-Party Cookies</h3>
            <p className="text-slate-600 mb-4">
              These are cookies that are set by our website directly. We use first-party cookies to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>Remember your preferences</li>
              <li>Understand how you use our website</li>
              <li>Improve your browsing experience</li>
            </ul>

            <h3 className="font-bold text-slate-800 mt-6 mb-2">Third-Party Cookies</h3>
            <p className="text-slate-600 mb-4">
              These are cookies that are set by a domain other than our website. We use third-party 
              cookies from:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li><strong>Google Analytics:</strong> To analyze website traffic and user behavior</li>
              <li><strong>Google Ads:</strong> To display relevant advertisements</li>
              <li><strong>Social Media Platforms:</strong> To enable social sharing features</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">Cookie Duration</h2>
            <p className="text-slate-600 mb-4">Cookies can be classified by how long they last:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li><strong>Session Cookies:</strong> These are temporary cookies that expire when you close your browser.</li>
              <li><strong>Persistent Cookies:</strong> These cookies remain on your device until they expire or you delete them. They can last from a few days to several years.</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">Managing Cookies</h2>
            <p className="text-slate-600 mb-4">
              You can control and manage cookies in various ways. Please note that removing or 
              blocking cookies may impact your user experience and parts of our website may no 
              longer be fully accessible.
            </p>
            <h3 className="font-bold text-slate-800 mt-6 mb-2">Browser Settings</h3>
            <p className="text-slate-600 mb-4">
              Most browsers allow you to refuse to accept cookies and to delete cookies. The 
              methods for doing so vary from browser to browser:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>Chrome: Settings → Privacy and Security → Cookies</li>
              <li>Firefox: Options → Privacy & Security → Cookies</li>
              <li>Safari: Preferences → Privacy → Cookies</li>
              <li>Edge: Settings → Privacy, Search, and Services → Cookies</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">Do Not Track</h2>
            <p className="text-slate-600 mb-8">
              Some browsers have a "Do Not Track" feature that lets you tell websites that you do 
              not want to have your online activities tracked. Our website currently does not 
              respond to "Do Not Track" signals.
            </p>

            <h2 className="heading-tertiary text-slate-900">Updates to This Policy</h2>
            <p className="text-slate-600 mb-8">
              We may update this Cookie Policy from time to time to reflect changes in technology, 
              legislation, or our business practices. Any changes will be posted on this page with 
              an updated revision date.
            </p>

            <h2 className="heading-tertiary text-slate-900">Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have any questions about our use of cookies, please contact us:
            </p>
            <ul className="list-none text-slate-600 mb-8">
              <li><strong>Email:</strong> support@buyvistas.store</li>
              <li><strong>Phone:</strong> +1-888-435-4674</li>
              <li><strong>Address:</strong> 20 E 22nd St #4699, New York, NY 10165</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-sky-600 hover:text-sky-700 font-semibold">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
